import { useEffect, useState } from 'react';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { useIsFirstProjectITSM } from '@atlassian/jira-servicedesk-getting-started-page/src/services';
import { useGettingStartedPanelState } from '@atlassian/jira-servicedesk-getting-started-panel-state';
import { PropertyKey, defaultGspState } from '@atlassian/jsm-getting-started-panel';

export const useInitializeActiveTab = (activeTabName: string, gspProjectId?: string) => {
	const { isFirstProject, isFirstProjectItsm } = useIsFirstProjectITSM(gspProjectId);
	const isNpleForItsmEnabled =
		isFirstProject &&
		isFirstProjectItsm &&
		expValEquals('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
	const [{ data: gspStateData }, { saveProperty }] = useGettingStartedPanelState();
	const [isInitializedActiveTab, setIsInitializedActiveTab] = useState(false);
	useEffect(() => {
		if (!isInitializedActiveTab && isNpleForItsmEnabled && gspStateData) {
			const sectionStateJSON =
				gspStateData.properties?.user?.sectionState ?? defaultGspState.properties.user.sectionState;
			const sectionState = JSON.parse(sectionStateJSON);
			if (sectionState.sections.checklist.activeTab !== activeTabName) {
				sectionState.sections.checklist.activeTab = activeTabName;
				saveProperty({
					key: PropertyKey.SectionState,
					value: JSON.stringify(sectionState),
				});
			}
			setIsInitializedActiveTab(true);
		}
	}, [isNpleForItsmEnabled, gspStateData, saveProperty, activeTabName, isInitializedActiveTab]);
};
